import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function Login() {
  const navigate = useNavigate();

  const [mode, setMode] = useState("login"); // "login" | "signup"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    setErrorMsg("");
    setMessage("");
    setLoading(true);

    try {
      if (mode === "login") {
        const { error } = await supabase.auth.signInWithPassword({
          email: email.trim(),
          password,
        });

        if (error) throw error;

        navigate("/projects");
        return;
      }

      const { data, error } = await supabase.auth.signUp({
  email: email.trim(),
  password,
  options: {
    data: {
      company_name:
        companyName.trim() || `${email.trim().split("@")[0]} Workspace`,
    },
  },
});

      if (error) throw error;

      if (!data.session) {
        setMessage(
          "Bruger oprettet. Tjek din email og bekræft kontoen før login."
        );
        setMode("login");
        setPassword("");
        return;
      }

      navigate("/projects");
    } catch (err) {
      setErrorMsg(err?.message || "Noget gik galt. Prøv igen.");
    } finally {
      setLoading(false);
    }
  }

  function toggleMode() {
    setMode((prev) => (prev === "login" ? "signup" : "login"));
    setErrorMsg("");
    setMessage("");
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f3f2f1] p-6">
      <div className="w-full max-w-md rounded-sm border border-[#edebe9] bg-white p-6 shadow-sm">
        <h1 className="mb-2 text-2xl font-semibold text-[#201f1e]">
          {mode === "login" ? "Log ind" : "Opret bruger"}
        </h1>

        <p className="mb-6 text-sm text-[#605e5c]">
          {mode === "login"
            ? "Log ind for at åbne dit tilbuds- og kundeworkspace."
            : "Opret en bruger for at komme i gang med Øresund Dashboard."}
        </p>

        {message && (
          <div className="mb-4 rounded-sm border border-[#bad80a] bg-[#f8fff0] px-3 py-2 text-sm text-[#107c10]">
            {message}
          </div>
        )}

        {errorMsg && (
          <div className="mb-4 rounded-sm border border-[#f3d6a0] bg-[#fff4ce] px-3 py-2 text-sm text-[#8a6d1d]">
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <Field label="Email">
            <input
              className="h-10 w-full rounded-sm border border-[#d2d0ce] px-3 text-sm text-[#201f1e] outline-none focus:border-[#0f6cbd]"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="din@email.dk"
              autoComplete="email"
              required
            />
          </Field>

        {mode === "signup" && (
          <Field label="Company / workspace name">
            <input
              className="h-10 w-full rounded-sm border border-[#d2d0ce] px-3 text-sm text-[#201f1e] outline-none focus:border-[#0f6cbd]"
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Øresund Byg"
              autoComplete="organization"
            />
          </Field>
        )}

          <Field label="Password">
            <input
              className="h-10 w-full rounded-sm border border-[#d2d0ce] px-3 text-sm text-[#201f1e] outline-none focus:border-[#0f6cbd]"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete={
                mode === "login" ? "current-password" : "new-password"
              }
              required
              minLength={6}
            />
          </Field>

          <button
            type="submit"
            disabled={loading}
            className="mt-2 h-10 w-full rounded-sm bg-[#0f6cbd] text-sm font-medium text-white hover:bg-[#115ea3] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading
              ? "Arbejder..."
              : mode === "login"
              ? "Log ind"
              : "Opret bruger"}
          </button>
        </form>

        <div className="mt-4 text-sm text-[#605e5c]">
          {mode === "login" ? (
            <>
              Har du ikke en bruger?{" "}
              <button
                type="button"
                onClick={toggleMode}
                className="font-medium text-[#0f6cbd] hover:underline"
              >
                Opret her
              </button>
            </>
          ) : (
            <>
              Har du allerede en bruger?{" "}
              <button
                type="button"
                onClick={toggleMode}
                className="font-medium text-[#0f6cbd] hover:underline"
              >
                Log ind
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="mb-1 text-sm font-medium text-[#323130]">{label}</div>
      {children}
    </label>
  );
}